<ng-container *transloco="let t" class="container">
  <div class="p-3">
    <div class="modal-header">
      <h5 class="modal-title">{{ title }}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="onDismissClick()">
      </button>
    </div>
    <div class="modal-body">
      <div class="mb-3 search-input-width">
        <app-search-rounded [placeholder]="t('explore.search')"
                            (searchEmitter)="handleSearchInput($event)"></app-search-rounded>
      </div>
      @if (filteredUsers && filteredUsers.length > 0) {
        <div class="table-responsive">
          <table [infiniteScrollDistance]="4" class="table table-last-row-no-border" infinite-scroll>
            <thead>
            <tr>
              <th scope="col" class="id-column-width">{{ t("event.item.id") }}</th>
              <th scope="col" class="name-column-width">{{ t("app.common.first.name") }}</th>
              <th scope="col" class="last-name-column-width">{{ t("app.common.last.name") }}</th>
              <th scope="col" class="phone-column-width">{{ t("app.common.mobilePhone") }}</th>
              <th scope="col" class="email-column-width">{{ t("app.common.email") }}</th>
              <th class="add-column-width"></th>
            </tr>
            </thead>
            <tbody>
              @for (user of filteredUsers;track user) {
                <tr>
                  <td class="center-align">{{ user.id }}</td>
                  <td class="center-align">{{ user.firstname ?? "-" }}</td>
                  <td class="center-align">{{ user.lastname ?? "-" }}</td>
                  <td class="center-align">{{ user.phoneNumber ?? "-" }}</td>
                  <td class="center-align" matTooltip="{{user.email ?? '-'}}">{{ user.email ?? "-" }}</td>
                  <td class="text-end center-align">
                    <span (click)="sendCouponToUser(user)" class="cursor-pointer"><i
                      class="far fa-paper-plane"></i></span>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <div class="px-3 px-lg-4">
          <app-empty-state/>
        </div>
      }
    </div>
    <div class="modal-footer">
      <div class="d-flex justify-content-end">
        <app-button (onClick)="onDismissClick()" [label]="t('app.common.cancel')"
                    [btnClass]="'btn-grey text-uppercase'"></app-button>
      </div>
    </div>
  </div>
</ng-container>
